/**
 * Composable pour extraire les composants d'une adresse Google
 * Limite: 50 lignes max
 */
export function useAddressExtraction() {
  const extractAddressComponents = (place) => {
    const components = place.address_components || []
    const result = {
      formattedAddress: place.formatted_address || '',
      streetNumber: '',
      route: '',
      locality: '',
      postalCode: '',
      country: '',
      administrativeArea: '',
      sublocality: ''
    }

    components.forEach(component => {
      const types = component.types

      if (types.includes('street_number')) {
        result.streetNumber = component.long_name
      }
      if (types.includes('route')) {
        result.route = component.long_name
      }
      if (types.includes('locality')) {
        result.locality = component.long_name
      }
      if (types.includes('postal_code')) {
        result.postalCode = component.long_name
      }
      if (types.includes('country')) {
        result.country = component.long_name
      }
      if (types.includes('administrative_area_level_1')) {
        result.administrativeArea = component.long_name
      }
      if (types.includes('sublocality') || types.includes('sublocality_level_1')) {
        result.sublocality = component.long_name
      }
    })

    result.streetAddress = [result.streetNumber, result.route].filter(Boolean).join(' ')

    if (!result.locality && result.sublocality) {
      result.locality = result.sublocality
    }

    return result
  }

  return { extractAddressComponents }
}
